var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.itemFlight.flight_includes),function(itemInclude){return _c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"service-card shadow-sm mb-4"},[_c('i',{class:`item-include ${itemInclude.custom_web_icon}`}),_vm._v(" "+_vm._s(itemInclude.additional_item_name_es)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }